const CategoriesPage = () => (
  <div className="categories-section">
    <button type="submit" className="status-btn">Check Status</button>
  </div>
);

export default CategoriesPage;
